module.exports = __webpack_public_path__ + "img/50_14.5f398a3e.png";